import { useState } from "react";
import { ImagePlus } from "lucide-react";
import { fetchApi } from "./access";
import { InlineLoader } from "../PageLoader";

/**
 * Instagram composer → "Generate an image" (restores the old InstagramHub's
 * Generate image, pages/instagram/InstagramHub.js:167,413).
 * POST /api/ai/ad-image { prompt, size, layout: "photo" } → { data: { url } }:
 * a square picture saved to the clinic's ad assets, with a public URL Instagram
 * can fetch, so it publishes like an uploaded photo. "photo" asks for a plain
 * picture: no lettering and no logo stamped where a face might be.
 */
export function InstagramImageGen({ caption = "", format = "Post", onImage, inputClass }) {
  const [subject, setSubject] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const topic = (subject || caption.split("\n")[0] || "").trim();
  const generate = async () => {
    if (topic.length < 3 || busy) return;
    setBusy(true); setError("");
    const r = await fetchApi("/api/ai/ad-image", {
      method: "post",
      body: { prompt: `Premium Instagram ${format.toLowerCase()} visual for a healthcare clinic. Subject: ${topic}. Modern, warm, scroll-stopping, square 1:1, no text in the image.`, size: "1024x1024", layout: "photo" },
    });
    setBusy(false);
    const url = r.ok ? r.data?.data?.url : null;
    if (!url) { setError(r.message || "The image wasn't made. Try again."); return; }
    onImage(url);
    setSubject("");
  };
  return <div className="rounded-sm bg-mist p-3">
    <p className="text-small font-semibold">Generate an image</p>
    <p className="mt-0.5 text-caption text-muted">Describe the picture, or leave it empty to use the caption. Takes about 20 seconds.</p>
    <div className="mt-2 flex flex-wrap gap-2">
      <input value={subject} onChange={(event) => setSubject(event.target.value)} onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); generate(); } }} placeholder={caption ? "Uses the caption" : "e.g. A smiling family at a dental check-up"} aria-label="Describe the image" disabled={busy} className={`${inputClass} min-w-0 flex-1 basis-52`} />
      <button type="button" onClick={generate} disabled={busy || topic.length < 3} className="flex h-10 shrink-0 items-center gap-2 rounded-full bg-ink px-4 text-small font-semibold text-paper hover:bg-ink/85 disabled:opacity-45">{busy ? <InlineLoader size={16} /> : <ImagePlus size={16} strokeWidth={1.75} />}{busy ? "Generating…" : "Generate"}</button>
    </div>
    {error && <p role="alert" className="mt-2 text-caption text-danger">{error}</p>}
  </div>;
}
